import React, { FC } from "react";
import { SurveysView } from "../components";

export const SurveysPage: FC = () => {
  return <SurveysView />;
};